export const LOAD_DATA = "LOAD_DATA";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const REDUCE_QUANTITY = "REDUCE_QUANTITY";
export const ORDER_CONFIRMED = "ORDER_CONFIRMED";
export const DISCOUNT = "DISCOUNT";

/* The following action types are used to alter state of cart */